// Tracks open overlay layers (popovers, modals) so only the topmost reacts to Escape and
// clicks inside a child layer don't dismiss its parent.

let counter = 0;
const stack: number[] = [];

export function pushLayer() {
  const id = ++counter;
  stack.push(id);
  return id;
}

export function popLayer(id: number) {
  const i = stack.lastIndexOf(id);
  if (i >= 0) stack.splice(i, 1);
}

export function isTopLayer(id: number) {
  return stack[stack.length - 1] === id;
}

/** True when the event target sits inside a layer opened after `id` (a child). */
export function inChildLayer(target: EventTarget | null, id: number) {
  let el = target instanceof Element ? target : null;
  while (el) {
    const layer = el.closest<HTMLElement>("[data-layer]");
    if (!layer) return false;
    if (Number(layer.dataset.layer) > id) return true;
    el = layer.parentElement;
  }
  return false;
}
